import { render } from "./ScientistProfileEdit.vue?vue&type=template&id=11274744&scoped=true"
import script from "./ScientistProfileEdit.vue?vue&type=script&lang=js"
export * from "./ScientistProfileEdit.vue?vue&type=script&lang=js"

import "./ScientistProfileEdit.vue?vue&type=style&index=0&id=11274744&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11274744"]])

export default __exports__